export const planningQuestions: string[] = [
  'What should I coach today?',
  'Which progression comes next?',
  'What is actually causing that technical error?',
  'Which drill should I use?',
  'How do I explain the position clearly?',
  'How should I adapt the session for a beginner?',
  'How do I progress an intermediate or advanced athlete?',
]

export const painPoints: string[] = [
  'Hours spent searching for Weightlifting drills, progressions and training ideas',
  'Repeating the same exercises because they are the easiest ones to remember',
  'Snatch and Clean & Jerk sessions that feel disconnected from one week to the next',
  'Trying to explain complex positions without clear visual references',
  'Correcting the final mistake without identifying where the lift actually started to break down',
  'Using random drills without knowing exactly what technical problem they solve',
  'Athletes progressing without a clear development pathway',
  "Strength and mobility work that is not always connected to the athlete's technical needs",
  'More time preparing sessions and less time actually coaching',
  'Entering training with ideas instead of a complete structure',
]
